import { BORDER, INK, YELLOW, YELLOW_HOVER } from '../style/verbaScholaPalette';

export const pronunciationCardSx = {
    backgroundColor: '#fff',
    border: `1px solid ${BORDER}`,
    borderRadius: '20px',
    boxShadow: '0 4px 12px rgba(22,58,99,.04)',
};
export const pronunciationButtonSx = {
    backgroundColor: YELLOW,
    color: INK,
    fontWeight: 700,
    textTransform: 'none',
    borderRadius: '12px',
    '&:hover': { backgroundColor: YELLOW_HOVER },
} as const;

export function pronunciationError(error: unknown): string {
    const response = (error as { response?: { status?: number; data?: { message?: string; error?: string } | string } })?.response;
    if (response?.status === 490) return 'Please verify your email in your profile before adding sentences.';
    if (response?.status === 492) return 'This account is read only. Sign in with your own account to make changes.';
    if (typeof response?.data === 'string') return response.data;
    if (typeof response?.data?.message === 'string') return response.data.message;
    if (typeof response?.data?.error === 'string') return response.data.error;
    return 'Unable to complete this request. Please try again.';
}
